import type { Step } from '@/components/wizard/Step';

import type { SetupOwnCloudState } from './SetupOwnCloudState';
import { ConnectSourceAccount } from './connectSourceAccount';

export const SetupOwnCloudSourceFlow: Step<SetupOwnCloudState> = {
  name: 'Connect Azure source account',
  Component: ConnectSourceAccount,
  nonReturnable: false,
};
